import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        settings: {},
    },
    actions: {
        updateSettings(context, payload) {

            console.log("action update settings", payload)
            context.commit('UPDATE_SETTINGS', payload)
        }
    },
    mutations: {
        UPDATE_SETTINGS(state, payload) {
            state.settings = payload
        }
    },
    getters: {
        hackerMode(state) {
            return state.settings.hasOwnProperty('hacker') && state.settings.hacker == true
        },
        encryptionKey(state) {
            return state.settings.encryption_key
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js